import { render, staticRenderFns } from "./ItemDepartments.vue?vue&type=template&id=27d370ba&"
import script from "./ItemDepartments.vue?vue&type=script&lang=js&"
export * from "./ItemDepartments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports